import React from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "../lib/settings-context";
import { buildWhatsAppUrl } from "../lib/whatsapp";
import { reportWhatsAppClick } from "../lib/whatsapp-beacon";
import WhatsAppIcon from "./WhatsAppIcon";

/** WhatsApp brand mark — shared inline SVG component. */
function WhatsAppGlyph({ className = "h-7 w-7" }) {
  return <WhatsAppIcon className={className} />;
}

export default function WhatsAppFab() {
  const { whatsappNumber, whatsappDefaultGreeting, whatsappFloatingEnabled } =
    useSettings();
  const { pathname } = useLocation();

  if (!whatsappFloatingEnabled) return null;
  if (pathname.startsWith("/admin")) return null;

  const href = buildWhatsAppUrl(whatsappNumber, whatsappDefaultGreeting);

  return (
    <a
      data-testid="whatsapp-fab"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      onClick={() => reportWhatsAppClick("fab")}
      className="fixed z-50 bottom-4 right-4 sm:bottom-6 sm:right-6 h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-lg shadow-emerald-900/25 grid place-items-center transition-transform duration-200 hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-emerald-300"
      style={{
        paddingBottom: "env(safe-area-inset-bottom)",
        paddingRight: "env(safe-area-inset-right)",
      }}
    >
      <WhatsAppGlyph className="h-7 w-7" />
    </a>
  );
}
